enum FileUploadStatus {
	SELECTED,
	LOADING,
	SUCCESS,
	ERROR
}

export default FileUploadStatus;
